module.exports = __webpack_public_path__ + "static/gallery33-81a7cb72f8908afad0fe47321869a6f1.png";